import {useMemo} from 'react';

import {FilterDialogSectionId} from 'filters/features/FilterDialog/types';
import {assertPolicyFilter, isPolicyFilter} from 'filters/types';
import {FilterTopbarItemId} from 'filters/features/FilterTopbar/types';

import {useWithClientTags} from 'core/hooks/authHooks';
import {createTreeViewSection} from 'filters/features/FilterDialog/sections/TreeViewSection/TreeViewSection';
import {useClientAgencyCodesTree} from 'modules/decisionsNext/hooks/trees/useClientAgencyCodesTree';
import {openFilterDialog} from 'filters';
import {createCounterItem} from 'filters/features/FilterTopbar/items/CounterItem/CounterItem';

import AccountsNewIcon from 'components/icons/metrics/accountsNew.svg';

import {useClientTagsTreeViewSelection} from './useClientTagsTreeViewSelection';

export const useClientTagsDialogSection = () => {
  const withClientTags = useWithClientTags();

  return useMemo(
    () =>
      withClientTags &&
      createTreeViewSection({
        id: FilterDialogSectionId.ClientTags,
        title: 'Client Tags',
        icon: AccountsNewIcon,
        useTreeData: useClientAgencyCodesTree,
        getDataOptions: value => ({
          skip: !value?.length,
        }),
        useTreeSelection: useClientTagsTreeViewSelection,
        getValue: filter => {
          assertPolicyFilter(filter);

          return filter.clientAgencyCodes ?? null;
        },
        onChange: (filter, value) => {
          assertPolicyFilter(filter);

          return {
            ...filter,
            clientAgencyCodes: value?.length ? value : undefined,
          };
        },
      }),
    [withClientTags]
  );
};

export const useClientTagsTopbarItem = () => {
  const withClientTags = useWithClientTags();

  return useMemo(
    () =>
      withClientTags &&
      createCounterItem({
        id: FilterTopbarItemId.ClientTag,
        entity: 'Client Tags',
        getCount: filter => {
          if (!isPolicyFilter(filter)) {
            return;
          }

          return filter.clientAgencyCodes?.length;
        },
        onClick: () => openFilterDialog(FilterDialogSectionId.ClientTags),
        onReset: filter => {
          assertPolicyFilter(filter);

          return {
            ...filter,
            clientAgencyCodes: undefined,
          };
        },
      }),
    [withClientTags]
  );
};
